import { createContext, useContext } from 'react'

/**
 * Whether the page renders outside the client-only PersistGate (`ssrContent` / `medleveOrganic` page props, set
 * by _app): its content is in the server HTML, so below-the-fold sections must be too (LazySection).
 */
export const SsrContentContext = createContext(false)

export const useSsrContent = () => useContext(SsrContentContext)

/**
 * Inside a LazySection of a server-rendered page: the section's server HTML is there for its text, so media that
 * would download on its own (autoplay videos, CSS background images) is left out of it and attached when the section renders near the
 * viewport (see ServerHtmlDeferred).
 */
export const DeferMediaContext = createContext(false)

export const useDeferMedia = () => useContext(DeferMediaContext) && typeof window === 'undefined'
